import React, { useId } from 'react';
import { Flex } from 'antd';
import { CustomInput } from '@/components';
import styles from './SavedListPanel.module.css';

interface ListNameFieldProps {
  value: string;
  onChange: (name: string) => void;
  error: string | null;
  placeholder?: string;
}

/** The saved list's "Name" input with its inline validation error. */
const ListNameField: React.FC<ListNameFieldProps> = ({
  value,
  onChange,
  error,
  placeholder,
}) => {
  const id = useId();
  return (
    <Flex vertical gap={4}>
      <label htmlFor={id} className={styles.label}>
        Name
      </label>
      <CustomInput
        id={id}
        placeholder={placeholder}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        bgColor='var(--light-gray)'
        border='0px'
        borderRadius='8px'
      />
      {error && <span className={styles.error}>{error}</span>}
    </Flex>
  );
};

export default ListNameField;
